import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';

export default class CircleConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'diameter',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {
		return {
			diameter: maximum_rectangle.get_shortest_side(),
		};
	}

	get_labels(): Record<string, string> {
		const { diameter } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			diameter,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			diameter: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'circular';
	}
}
